// eslint-disable-next-line import/prefer-default-export, no-unused-vars
export const cleanObject = (obj) => Object.fromEntries(
  // eslint-disable-next-line no-unused-vars
  Object.entries(obj).filter(([_, v]) => v !== undefined
    && v !== null
    && v !== ''
    && !(Array.isArray(v) && v.length === 0))
);
